import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

import { DAY, DAYS_TO_NUMBER } from "../../consts/strings";
import { DAY_PLAN } from "../../consts/sentryIds";
import { palette } from "../../theme/palette";

import StyledChip from "./StyledChip";
import { getDepotDays } from "../../reducers/matrixProfile/selectors";

export const DayChips = ({
  disableDaysNotInDepot = false,
  disableDaysInDepot = false,
  selected,
  onDaySelected,
  disabledDays = [],
  incompatibleDays = [],
}) => {
  const depotDays = useSelector(getDepotDays);

  const clickHandler = (day) => {
    onDaySelected && onDaySelected({ type: DAY, value: day });
  };

  const isSelected = (dayNumber) => {
    return Array.isArray(selected)
      ? selected.includes(dayNumber)
      : dayNumber === selected;
  };

  return Object.keys(DAYS_TO_NUMBER).map((day, index) => {
    const dayNumber = DAYS_TO_NUMBER[day];
    let disabled =
      (Array.isArray(disabledDays) && disabledDays.includes(dayNumber)) ||
      (disableDaysNotInDepot && !depotDays.includes(DAYS_TO_NUMBER[day])) ||
      (disableDaysInDepot && depotDays.includes(DAYS_TO_NUMBER[day]));
    let incompatible =
      Array.isArray(incompatibleDays) && incompatibleDays.includes(dayNumber);

    let style = {};
    if (disabled)
      style = {
        backgroundColor: palette.dpdLightGrey,
        pointerEvents: "none",
        color: palette.typography.white.high,
      };
    else if (incompatible)
      style = {
        backgroundColor: palette.dpdLightGrey,
        color: palette.typography.white.high,
      };
    else if (isSelected(dayNumber))
      style = {
        backgroundColor: palette.dpdRed,
        color: palette.typography.white.high,
      };

    if (incompatible)
      return (
        <Tooltip
          key={index}
          title={
            "You cannot copy to this plan as it uses a different postcode allocation."
          }
        >
          <StyledChip
            sentryId={`${DAY_PLAN}__${dayNumber}`}
            dark
            size={"small"}
            clickable
            label={day}
            style={style}
          />
        </Tooltip>
      );
    else
      return (
        <StyledChip
          sentryId={`${DAY_PLAN}__${dayNumber}`}
          dark
          size={"small"}
          clickable
          label={day}
          key={index}
          onClick={() => clickHandler(DAYS_TO_NUMBER[day])}
          style={style}
        />
      );
  });
};
